export const GET_EXPENSE_ACCOUNTS_VALIDATION = 'GET_EXPENSE_ACCOUNTS_VALIDATION';
export const GET_EXPENSE_ACCOUNTS_VALIDATION_SUCCESS = 'GET_EXPENSE_ACCOUNTS_VALIDATION_SUCCESS';
export const GET_EXPENSE_ACCOUNTS_VALIDATION_ERROR = 'GET_EXPENSE_ACCOUNTS_VALIDATION_ERROR';
export const SET_EXPENSE_ACCOUNTS_VALIDATION_FILTERS = 'SET_EXPENSE_ACCOUNTS_VALIDATION_FILTERS';

/** Estados de la validación interna. Coinciden con el enum del backend. */
export type ExpenseAccountStatus = 'PENDING_VALIDATION' | 'REJECTED' | 'APPROVED';

/** Un renglón del listado interno (HU 2, criterio 1). */
export interface IExpenseAccountValidationRow {
    expenseAccountId: string;
    customRequestId: string;
    /** Número del Agente Aduanal. */
    customAgent: string;
    /** Número de pedimento. */
    customRequest: string;
    society: string;
    folio: string;
    version: number;
    uploadedAt: string;
    status: ExpenseAccountStatus;
    statusLabel: string;
    /**
     * Fecha y correo de la decisión. Vienen en `null` mientras está pendiente de
     * validación, que es lo que pide el criterio 1: las columnas se muestran vacías.
     */
    decidedAt: string | null;
    decidedBy: string | null;
    notesCount: number;
    hasNotes: boolean;
    /** Fecha del envío a SAP. `null` mientras no se haya liberado (criterio 13). */
    processedAt: string | null;
    isProcessed: boolean;
    canApprove: boolean;
    canReject: boolean;
    canDownloadZip: boolean;
}

/** Filtros del criterio 12. Los rangos se mandan como fecha, el resto como texto. */
export interface IExpenseAccountValidationFilters {
    uploadedFrom?: Date | string;
    uploadedTo?: Date | string;
    decidedFrom?: Date | string;
    decidedTo?: Date | string;
    society?: string;
    customAgent?: string;
    folio?: string;
    status?: string;
    decidedBy?: string;
    year?: string;
}
